import { createApi } from '@reduxjs/toolkit/query/react';
import { HYDRATE } from 'next-redux-wrapper';
import { fetchQuery } from './helpers/fetchQuery';

export const productGraphApi = createApi({
  reducerPath: 'productGraphApi',
  tagTypes: ['ProductGraphVenture'],
  baseQuery: fetchQuery({ subDomain: 'pg.api', basePath: '/v1/gql/customer' }),
  extractRehydrationInfo(action, { reducerPath }): any {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  endpoints: builder => ({})
});
